import React, { useState } from "react";
import {
  Box,
  Checkbox,
  Collapse,
  FormControl,
  FormControlLabel,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import {
  CheckboxFormField,
  InternationalAddressFields,
  TextFormField,
} from "../common/components/FormFields";
import MuiPeople from "@mui/icons-material/People";
import { FoodProgramAddressFields } from "./FoodProgramAddressFields";
import { Helmet } from "react-helmet";
import { useField } from "react-final-form";
import { useFieldValue } from "../common/hooks/useFieldValue";

export interface FoodProgramParentFieldsProps {}

export function FoodProgramParentFields({}: FoodProgramParentFieldsProps) {
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up("md"));

  const includeSecondParent = useFieldValue<boolean>("includeSecondParent");

  return (
    <>
      <Helmet>
        <title>ISR School Foods Program</title>
      </Helmet>
      <Box>
        <Box pb={1}>
          <Typography variant="h5">Parent/Guardian</Typography>
        </Box>
        <Grid container spacing={0.5}>
          <Grid item md={4} xs={12}>
            <TextFormField
              name="parent1.name"
              label="Name"
              icon={<MuiPeople />}
              required
            />
          </Grid>
          <Grid item md={4} xs={12}>
            <TextFormField
              name="parent1.contactNumber"
              label="Contact Number"
              required
              noIcon={md}
            />
          </Grid>
          <Grid item md={4} xs={12}>
            <TextFormField
              name="parent1.email"
              label="Email"
              noIcon={md}
              required
            />
          </Grid>
          <Grid item xs={12} sx={{ mt: 1 }}>
            <CheckboxFormField
              name="includeSecondParent"
              label="Include Second Parent/Guardian"
            />
          </Grid>
          <Grid item container xs={12}>
            <Collapse
              in={includeSecondParent}
              unmountOnExit
              sx={{ width: "100%" }}
            >
              <Stack spacing={1} direction={{ xs: "column", md: "row" }}>
                <Box flex={1}>
                  <TextFormField
                    name="parent2.name"
                    label="Name"
                    icon={<MuiPeople />}
                    required
                  />
                </Box>
                <Box flex={1}>
                  <TextFormField
                    name="parent2.contactNumber"
                    label="Contact Number"
                    noIcon={md}
                    required
                  />
                </Box>
                <Box flex={1}>
                  <TextFormField
                    name="parent2.email"
                    label="Email"
                    noIcon={md}
                    required
                  />
                </Box>
              </Stack>
            </Collapse>
          </Grid>
          <Grid item xs={12}>
            <FoodProgramAddressFields
              required
              namespace="address"
              label="Address"
            />
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
